var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "backToIngredients" } }, [
    _c(
      "a",
      { staticStyle: { display: "block" }, attrs: { href: _vm.urlPath } },
      [
        _c("div", { staticClass: "research_thumbnail_container" }, [
          _c("img", {
            attrs: {
              alt: "Ingredients",
              src: "/CKFinderJava/userfiles/images/2021/DK/Ingredienser-thumbnail-v2.jpg",
            },
          }),
          _c("span", { staticClass: "btn-research-corner" }, [
            _vm._v(
              _vm._s(this.$root.language.wsm_backToOverview.toUpperCase())
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }